import { pushDLActionVideo } from './../utilities/datalayer.util';
export class CoasVideoPreview {
    constructor(containerVideoId) {
        this.containerVideoId = containerVideoId;
        console.log("ID VIDEO : ", this.containerVideoId);
    }
    onInit() {
        const containerVideo = document.getElementById(this.containerVideoId);
        if (!containerVideo)
            return console.log(`Not element fount with '${this.containerVideoId}' Id`);
        const imgPreview = containerVideo.getAttribute('srcImg');
        const ytVideoCode = containerVideo.getAttribute('srcVideoCode');
        console.log({ imgPreview, ytVideoCode });
        if (!ytVideoCode)
            return console.log(`Not YT code with '${ytVideoCode}' value`);
        if (!imgPreview || imgPreview == "") {
            const internalContent = `<iframe title="YouTube video player" src="https://www.youtube.com/embed/${ytVideoCode}?autoplay=0&rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
            containerVideo.innerHTML = internalContent;
        }
        else {
            // Creamos la estructura interna
            const internalContent = `<div class="video-container-image">` +
                `<img class="relative z-10 w-full" src="${imgPreview}" loading="lazy" alt="landing video">` +
                `</div>` +
                `<div id=${ytVideoCode}></div>`;
            containerVideo.innerHTML = internalContent;
            // Agregamos el evento click de la imagen
            const myImage = containerVideo.querySelector('div.video-container-image');
            myImage && this.clickPosterVideo(myImage, ytVideoCode);
        }
    }
    clickPosterVideo(imageReference, ytVideoCode) {
        const landingPosterVideo = imageReference;
        landingPosterVideo && landingPosterVideo.addEventListener('click', () => {
            landingPosterVideo.style.display = 'none';
            this.onYouTubeIframeAPIReady(ytVideoCode);
        });
    }
    onYouTubeIframeAPIReady(videoID) {
        console.log("Entramos a esta pate");
        this.player = new window.YT.Player(videoID, {
            videoId: `${videoID}`,
            playerVars: {
                'autoplay': 1,
                'origin': `${window.location.href}`
            },
            events: {
                'onStateChange': (event) => {
                    const videoName = this.player.getVideoData().title;
                    switch (event.data) {
                        case window.YT.PlayerState.PLAYING:
                            pushDLActionVideo(videoName, 'Play', 'landing');
                            console.log("Play video");
                            break;
                        case window.YT.PlayerState.PAUSED:
                            pushDLActionVideo(videoName, 'Pause', 'landing');
                            console.log("Play paused");
                            break;
                        case window.YT.PlayerState.ENDED:
                            pushDLActionVideo(videoName, 'Completed', 'landing');
                            console.log("Play ended");
                            break;
                    }
                }
            }
        });
    }
}
